<template>
  <section class="tai-xiu-board" :class="{ compact, full, fancy: isFancy, 'betting-closed': !isBetOpen }">
    <header v-if="!full && !hideHeader" class="board-header">
      <div class="table-identity">
        <strong>
          <span class="table-id">{{ table.code }} #{{ table.round }}</span>
        </strong>
        <span v-if="!isFancy">{{ table.name }}</span>
      </div>
      <TaiXiuDiceRow
        v-if="isFancy"
        class="header-dice"
        :table="table"
        :is-rolling="isRolling"
        float-result
      />
      <div v-if="isFancy" class="time">
        <!-- <div class="timer" :class="{ closing: table.secondsRemaining <= 5 }">
          00:{{ paddedSeconds }}s
        </div> -->
        <button
          v-if="compact"
          class="sheet-close"
          type="button"
          :aria-label="$t('Close')"
          @click="onClose"
        >
          <img src="@/assets/images/quick-play-close.svg" alt="" />
        </button>
      </div>
      <div v-else-if="table.autoClose" class="timer" :class="{ closing: table.secondsRemaining <= 5 }">
        00:{{ paddedSeconds }}s
      </div>
    </header>

    <div v-if="!isFancy" class="mock-video">
      <div class="video-label">{{ $t('Mock Tài Xỉu feed') }}</div>
      <div class="dice-result" :class="{ rolling: diceAreRolling, continuous: diceAreRollingContinuously }">
        <img
          v-for="(die, index) in resultDice"
          :key="index"
          :src="diceImage(die)"
          :alt="`Die ${index + 1}: ${die}`"
        />
      </div>
      <small>{{ $t('Prototype data only') }}</small>
    </div>

    <template v-if="isFancy">
      <div class="full-board-body">
        <div class="tx-info-bar">{{ $t('ALL PAY') }} {{ bigSmallOdds }}</div>

        <div class="tx-main-row">
          <button
            type="button"
            class="tx-main-bet tx-main-bet--tai"
            :class="{
              selected: displayBets.tai,
              'result-matched': isResultMatch('tai'),
              blocked: isSelectionBlocked('tai'),
            }"
            :disabled="!isBetOpen || isSelectionBlocked('tai')"
            @click="onBet('tai')"
          >
            <span>TÀI</span>
            <span class="sub">BIG 11-17</span>
            <BetPlacedChip
              v-if="displayBets.tai"
              :amount="displayBets.tai"
              :chips="chips"
              placement="top-left"
            />
          </button>

          <div class="tx-odd-even">
            <button
              type="button"
              class="tx-odd-even__btn tx-odd-even__btn--odd"
              :class="{
                selected: displayBets.odd,
                'result-matched': isResultMatch('odd'),
                blocked: isSelectionBlocked('odd'),
              }"
              :disabled="!isBetOpen || isSelectionBlocked('odd')"
              @click="onBet('odd')"
            >
              <span>LẺ</span>
              <small>ODD</small>
              <BetPlacedChip
                v-if="displayBets.odd"
                :amount="displayBets.odd"
                :chips="chips"
                placement="top-right"
                overlap
              />
            </button>
            <button
              type="button"
              class="tx-odd-even__btn tx-odd-even__btn--even"
              :class="{
                selected: displayBets.even,
                'result-matched': isResultMatch('even'),
                blocked: isSelectionBlocked('even'),
              }"
              :disabled="!isBetOpen || isSelectionBlocked('even')"
              @click="onBet('even')"
            >
              <span>CHẴN</span>
              <small>EVEN</small>
              <BetPlacedChip
                v-if="displayBets.even"
                :amount="displayBets.even"
                :chips="chips"
                placement="top-right"
                overlap
              />
            </button>
          </div>

          <button
            type="button"
            class="tx-main-bet tx-main-bet--xiu"
            :class="{
              selected: displayBets.xiu,
              'result-matched': isResultMatch('xiu'),
              blocked: isSelectionBlocked('xiu'),
            }"
            :disabled="!isBetOpen || isSelectionBlocked('xiu')"
            @click="onBet('xiu')"
          >
            <span>XỈU</span>
            <span class="sub">SMALL 4-10</span>
            <BetPlacedChip
              v-if="displayBets.xiu"
              :amount="displayBets.xiu"
              :chips="chips"
              placement="top-right"
            />
          </button>
        </div>

        <div v-if="!compact" class="tx-triple-section">
          <div class="tx-info-bar tx-info-bar--triple">{{ $t('TRIPLE') }} {{ tripleOdds }}</div>

          <div class="tx-triple-row">
            <BetTripleComboBtn
              v-for="slot in tripleComboSlots"
              :key="slot.face"
              :face="slot.face"
              :odds="tripleOdds"
              :selected="!!displayBets[`triple-${slot.face}`]"
              :result-matched="isResultMatch(`triple-${slot.face}`)"
              :amount="displayBets[`triple-${slot.face}`]"
              :chips="chips"
              @click="onBet(`triple-${slot.face}`)"
            />
          </div>
        </div>

        <div class="full-sum-rows">
          <div class="sum-grid">
            <button
              v-for="sum in lowSums"
              :key="sum"
              type="button"
              :class="{
                selected: displayBets[`sum-${sum}`],
                'result-matched': isResultMatch(`sum-${sum}`),
              }"
              :disabled="!isBetOpen"
              @click="onBet(`sum-${sum}`)"
            >
              <strong>{{ sum }}</strong>
              <small>{{ totalOdds(sum) }}</small>
              <BetPlacedChip
                v-if="displayBets[`sum-${sum}`]"
                :amount="displayBets[`sum-${sum}`]"
                :chips="chips"
                placement="top-right"
                overlap
              />
            </button>
          </div>
          <div class="sum-grid">
            <button
              v-for="sum in highSums"
              :key="sum"
              type="button"
              :class="{
                selected: displayBets[`sum-${sum}`],
                'result-matched': isResultMatch(`sum-${sum}`),
              }"
              :disabled="!isBetOpen"
              @click="onBet(`sum-${sum}`)"
            >
              <strong>{{ sum }}</strong>
              <small>{{ totalOdds(sum) }}</small>
              <BetPlacedChip
                v-if="displayBets[`sum-${sum}`]"
                :amount="displayBets[`sum-${sum}`]"
                :chips="chips"
                placement="top-right"
                overlap
              />
            </button>
          </div>
        </div>

        <div class="tx-info-bar tx-info-bar--single">
          <span>{{ $t('SINGLE') }} {{ singleOdds }}</span>
          <span>{{ $t('DOUBLE') }} {{ doubleOdds }}</span>
          <span>{{ $t('TRIPLE') }} {{ singleTripleOdds }}</span>
        </div>

        <BetDiceMarketSection
          class="tx-dice-market"
          :draft-bets="displayBets"
          :chips="chips"
          :die-faces="dieFaces"
          :show-triple="false"
          :matched-faces="showResultHighlights ? tableResultDice : []"
          :single-odds="singleOdds"
          :double-odds="doubleOdds"
          :triple-odds="singleTripleOdds"
          @bet="onBet"
        />
      </div>

      <!--
        Empty everywhere else. The desktop single view puts the table rail here,
        between the markets and the chip row, which is where the design has it.
      -->
      <slot name="under-board" />

      <!--
        Not wrapped: a sticky element can only travel inside its own parent, so
        a wrapper that starts below the fold could never pin the chip row on
        load. As a direct child of the board its range is the whole board.
      -->
      <BetBoardActions
        :chips="chips"
        :active-chip="activeChip"
        :chip-colors="chipColors"
        :can-undo="canUndo"
        :has-bets="hasBets"
        :total-bet="totalBet"
        :currency-symbol="currencySymbol"
        :is-submitting="isSubmitting"
        :is-rolling="isRolling"
        :betting-disabled="!isBetOpen"
        :pin-bottom="false"
        :arena-id="tableArenaId"
        fancy
        @undo="$emit('undo')"
        @clear="$emit('clear')"
        @select-chip="$emit('select-chip', $event)"
        @submit="$emit('submit')"
      />
      <BetHistoryCharts
        v-if="full && !hideCharts"
        :recent-results="table.recentResults"
        :recent-dice="table.recentDice"
        :recent-rounds="table.recentRounds"
        :code="table.code"
      />
    </template>

    <template v-else>
      <div class="primary-bets">
        <button
          type="button"
          class="primary-bet-tai"
          :class="{
            selected: displayBets.tai,
            'result-matched': isResultMatch('tai'),
            blocked: isSelectionBlocked('tai'),
          }"
          :disabled="!isBetOpen || isSelectionBlocked('tai')"
          @click="onBet('tai')"
        >
          <span>TÀI</span>
          <span class="primary-bet-tai sub">BIG 11-17</span>
          <small class="odds">{{ bigSmallOdds }}</small>
          <BetPlacedChip
            v-if="displayBets.tai"
            :amount="displayBets.tai"
            :chips="chips"
            placement="top-left"
          />
        </button>

        <div class="secondary-bets">
          <button
            type="button"
            :class="{
              selected: displayBets.odd,
              'result-matched': isResultMatch('odd'),
              blocked: isSelectionBlocked('odd'),
            }"
            :disabled="!isBetOpen || isSelectionBlocked('odd')"
            @click="onBet('odd')"
          >
            <span>LẺ - ODD</span>
            <small>{{ oddEvenOdds }}</small>
            <BetPlacedChip
              v-if="displayBets.odd"
              :amount="displayBets.odd"
              :chips="chips"
              placement="top-right"
            />
          </button>
          <button
            type="button"
            :class="{
              selected: displayBets.even,
              'result-matched': isResultMatch('even'),
              blocked: isSelectionBlocked('even'),
            }"
            :disabled="!isBetOpen || isSelectionBlocked('even')"
            @click="onBet('even')"
          >
            <span>CHẴN - EVEN</span>
            <small>{{ oddEvenOdds }}</small>
            <BetPlacedChip
              v-if="displayBets.even"
              :amount="displayBets.even"
              :chips="chips"
              placement="top-right"
            />
          </button>
        </div>

        <button
          type="button"
          class="primary-bet-xiu"
          :class="{
            selected: displayBets.xiu,
            'result-matched': isResultMatch('xiu'),
            blocked: isSelectionBlocked('xiu'),
          }"
          :disabled="!isBetOpen || isSelectionBlocked('xiu')"
          @click="onBet('xiu')"
        >
          <span>XỈU</span>
          <span class="primary-bet-xiu sub">SMALL 4-10</span>
          <small class="odds">{{ bigSmallOdds }}</small>
          <BetPlacedChip
            v-if="displayBets.xiu"
            :amount="displayBets.xiu"
            :chips="chips"
            placement="top-right"
          />
        </button>
      </div>

      <div class="sum-grid">
      <button
        v-for="sum in sums"
        :key="sum"
        type="button"
        :class="{
          selected: displayBets[`sum-${sum}`],
          'result-matched': isResultMatch(`sum-${sum}`),
        }"
        :disabled="!isBetOpen"
        @click="onBet(`sum-${sum}`)"
      >
        <strong>{{ sum }}</strong>
        <small>{{ totalOdds(sum) }}</small>
        <BetPlacedChip
          v-if="displayBets[`sum-${sum}`]"
          :amount="displayBets[`sum-${sum}`]"
          :chips="chips"
          placement="top-right"
          overlap
        />
      </button>
      </div>

      <BetDiceMarketSection
        :draft-bets="displayBets"
        :chips="chips"
        :die-faces="dieFaces"
        :show-triple="full"
        :matched-faces="showResultHighlights ? tableResultDice : []"
        :single-odds="singleOdds"
        :double-odds="doubleOdds"
        :triple-odds="singleTripleOdds"
        @bet="onBet"
      />

      <BetBoardActions
        v-if="isFancy"
        :chips="chips"
        :active-chip="activeChip"
        :chip-colors="chipColors"
        :can-undo="canUndo"
        :has-bets="hasBets"
        :total-bet="totalBet"
        :currency-symbol="currencySymbol"
        :is-submitting="isSubmitting"
        :is-rolling="isRolling"
        :betting-disabled="!isBetOpen"
        :arena-id="tableArenaId"
        fancy
        @undo="$emit('undo')"
        @clear="$emit('clear')"
        @select-chip="$emit('select-chip', $event)"
        @submit="$emit('submit')"
      />

      <div v-else class="board-actions">
        <button
          type="button"
          class="undo-action"
          :disabled="!canUndo"
          @mousedown="onUndoPressStart('mousedown')"
          @mouseup="onUndoPressEnd('mouseup')"
          @mouseleave="onUndoPressCancel"
          @touchstart.prevent="onUndoPressStart('touchstart')"
          @touchend="onUndoPressEnd('touchend')"
          @touchcancel="onUndoPressCancel"
        >
          <img src="@/assets/svg/btns/undo.svg" alt="" />
          <small>{{ $t('Undo') }}</small>
        </button>
        <BetChipSelector
          class="chips"
          :chips="chips"
          :active-chip="activeChip"
          :chip-colors="chipColors"
          :fancy="false"
          :arena-id="tableArenaId"
          @select-chip="$emit('select-chip', $event)"
        />
        <button type="button" class="text-action" :disabled="!hasBets" @click="$emit('clear')">
          {{ $t('Clear') }}
        </button>
        <div class="stake-total">
          <span>STAKE</span>
          <strong>{{ currencySymbol }} {{ formatAmount(totalBet) }}</strong>
        </div>
        <button
          type="button"
          class="bet-action"
          :disabled="isSubmitting || isRolling || !isBetOpen || !hasBets"
          @click="$emit('submit')"
        >
          {{ isRolling ? $t('Rolling') : $t('Bet') }}
        </button>
      </div>
    </template>

    <p v-if="feedback && !isFancy" class="feedback" role="status">{{ $t(feedback) }}</p>

    <div v-if="!isFancy" class="recent-results">
      <span>{{ $t('Recent results') }}</span>
      <i
        v-for="(result, index) in table.recentResults"
        :key="`${result}-${index}`"
        :class="result > 10 ? 'tai' : 'xiu'"
      >
        {{ result }}
      </i>
    </div>
  </section>
</template>

<script>
import BetBoardActions from '@/components/tai-xiu/bet-board-actions.vue';
import BetChipSelector from '@/components/tai-xiu/bet-chip-selector.vue';
import BetDiceMarketSection from '@/components/tai-xiu/bet-dice-market-section.vue';
import BetHistoryCharts from '@/components/tai-xiu/bet-history-charts.vue';
import BetPlacedChip from '@/components/tai-xiu/bet-placed-chip.vue';
import BetTripleComboBtn from '@/components/tai-xiu/bet-triple-combo-btn.vue';
import TaiXiuDiceRow from '@/components/tai-xiu/tai-xiu-dice-row.vue';
import { formatAmount } from '@/utils/helpers';
import { TaiXiuBetType } from '@/utils/index.model';
import { fallbackTotalGameOdds, formatTaiXiuOdds, taiXiuGameOdds } from '@/utils/tai-xiu-market';
import { TAI_XIU_BET_OPEN_STATUSES, TAI_XIU_RESULT_STATUSES, TaiXiuRoundStatus } from '@/utils/tai-xiu.model';
import { EXCLUSIVE_SELECTIONS, getLatestTableDice, getTaiXiuDice } from '@/store/modules/tai-xiu';
import { isMobile } from 'mobile-device-detect';
import { mapGetters } from 'vuex';

const UNDO_HOLD_MS = 500;

export default {
  components: {
    BetBoardActions,
    BetChipSelector,
    BetDiceMarketSection,
    BetHistoryCharts,
    BetPlacedChip,
    BetTripleComboBtn,
    TaiXiuDiceRow,
  },
  props: {
    table: {
      type: Object,
      required: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    /*
     * The desktop quick-play card draws its own header (ID, dice, countdown,
     * close) in the rail's chrome, so it asks the board to leave its built-in
     * one out. Default false keeps the mobile sheet exactly as it was.
     */
    hideHeader: {
      type: Boolean,
      default: false,
    },
    /*
     * Leave the road charts out of the board. The desktop single view puts them
     * in its left column, beside the betting rather than under it; everywhere
     * else the board still draws its own.
     */
    hideCharts: {
      type: Boolean,
      default: false,
    },
    full: {
      type: Boolean,
      default: false,
    },
    activeChip: {
      type: Number,
      required: true,
    },
    draftBets: {
      type: Object,
      required: true,
    },
    placedBets: {
      type: Object,
      default: () => ({}),
    },
    canUndo: {
      type: Boolean,
      default: false,
    },
    feedback: {
      type: String,
      default: '',
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
    isRolling: {
      type: Boolean,
      default: false,
    },
    lastResult: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isResultAnimating: false,
      resultAnimationTimer: null,
      chipColors: ['blue', 'orange', 'black', 'purple', 'yellow'],
      sums: [4, 5, 6, 7, 8, 9, 10, 17, 16, 15, 14, 13, 12, 11],
      lowSums: [4, 5, 6, 7, 8, 9, 10],
      highSums: [17, 16, 15, 14, 13, 12, 11],
      tripleComboSlots: [
        { face: 1, mirrored: false },
        { face: 2, mirrored: false },
        { face: 3, mirrored: false },
        { face: 4, mirrored: true },
        { face: 5, mirrored: true },
        { face: 6, mirrored: true },
      ],
      dieFaces: [1, 2, 3, 4, 5, 6],
      formatAmount,
      undoHoldTimer: null,
      undoHoldClearTriggered: false,
    };
  },
  computed: {
    ...mapGetters({
      config: 'general/config',
      member: 'general/member',
      arenaBetChips: 'general/arenaBetChips',
      arenaCustomBetChip: 'general/arenaCustomBetChip',
    }),
    currencySymbol() {
      return this.member.currencySymbol || '';
    },
    tableArenaId() {
      return (this.table && this.table.arenaId) || '';
    },
    chips() {
      // Four chips from this table's arena (GET /arenas/:id/bet-chips), which
      // falls back to the global config; the fifth slot is the shared
      // CustomChip, which owns the custom value itself.
      const chips = this.arenaBetChips(this.tableArenaId);
      return chips.length ? chips.slice(0, 4) : [5, 25, 100, 500];
    },
    totalBet() {
      return Object.keys(this.draftBets).reduce((sum, key) => sum + this.draftBets[key], 0);
    },
    displayBets() {
      return Object.keys(this.draftBets).reduce(
        (bets, selection) => ({
          ...bets,
          [selection]: (bets[selection] || 0) + this.draftBets[selection],
        }),
        { ...this.placedBets }
      );
    },
    hasBets() {
      return this.totalBet > 0;
    },
    tableResultDice() {
      // This round's own result, or null while it has none.
      return getTaiXiuDice(this.table.result) || null;
    },
    resultDice() {
      // The latest result known for the table -- see getLatestTableDice. Never
      // dice derived from a total: that fallback showed [4, 4, 4] whenever the
      // round had no parsed result.
      return getLatestTableDice(this.table) || [];
    },
    diceAreRolling() {
      return this.isRolling || this.isResultAnimating || this.table.fightStatus === TaiXiuRoundStatus.revealing;
    },
    diceAreRollingContinuously() {
      return !this.isResultAnimating && (this.isRolling || this.table.fightStatus === TaiXiuRoundStatus.revealing);
    },
    resultTotal() {
      return this.tableResultDice
        ? this.tableResultDice.reduce((total, face) => total + face, 0)
        : null;
    },
    showResultHighlights() {
      return !!this.tableResultDice &&
        TAI_XIU_RESULT_STATUSES.includes(this.table.fightStatus);
    },
    winAmount() {
      if (!this.showResultHighlights) return 0;
      return Object.keys(this.placedBets).reduce((sum, selection) => {
        if (!this.isResultMatch(selection)) return sum;
        const stake = this.placedBets[selection] || 0;
        const odds = this.selectionOdds(selection);
        return sum + stake * (1 + odds);
      }, 0);
    },
    showPayoutBanner() {
      return this.showResultHighlights && this.winAmount > 0;
    },
    resultAnimationKey() {
      return `${this.table.currentFightId || ''}|${this.table.fightStatus || ''}|${this.table.result || ''}`;
    },
    paddedSeconds() {
      return `0${this.table.secondsRemaining || 0}`.slice(-2);
    },
    isFancy() {
      return this.compact || this.full;
    },
    isBetOpen() {
      return TAI_XIU_BET_OPEN_STATUSES.includes(this.table.fightStatus);
    },
    bigSmallOdds() {
      return this.oddsLabel(TaiXiuBetType.bigSmall, 0.97);
    },
    oddEvenOdds() {
      return this.oddsLabel(TaiXiuBetType.oddEven, 0.97);
    },
    // A single face pays once per matching die: 1, 2 or 3 times the single odds.
    singleFaceOdds() {
      return this.oddsValue(TaiXiuBetType.single, 0.97);
    },
    singleOdds() {
      return formatTaiXiuOdds(this.singleFaceOdds);
    },
    doubleOdds() {
      return formatTaiXiuOdds(this.singleFaceOdds * 2);
    },
    singleTripleOdds() {
      return formatTaiXiuOdds(this.singleFaceOdds * 3);
    },
    tripleOdds() {
      return this.oddsLabel(TaiXiuBetType.triple, 120);
    },
  },
  watch: {
    // A win is announced as a pill over the video (video-toast.vue), where the
    // pink PAYOUT ribbon used to sit. Only a win that lands while the board is
    // open: not immediate, so a reload onto a decided round shows nothing.
    showPayoutBanner(won) {
      if (!won || !this.full || !this.table) return;
      this.$store.commit('taiXiu/SHOW_VIDEO_TOAST', {
        tableId: this.table.id,
        kind: 'payout',
        amount: this.winAmount,
      });
    },
    resultAnimationKey: {
      immediate: true,
      handler() {
        if (this.table.fightStatus !== TaiXiuRoundStatus.revealing || !this.tableResultDice) return;
        this.playResultAnimation();
      },
    },
    chips: {
      immediate: true,
      handler(chips) {
        // The custom chip is a valid pick too. Without this, every re-fetch of
        // the arena's chips (one rides along with each odds refresh) threw a
        // member on their custom amount back to the first chip.
        const active = Number(this.activeChip);
        const custom = Number(this.arenaCustomBetChip(this.tableArenaId)) || 0;
        if (chips.length && !chips.includes(active) && !(custom > 0 && active === custom)) {
          this.$emit('select-chip', chips[0]);
        }
      },
    },
  },
  beforeDestroy() {
    clearTimeout(this.resultAnimationTimer);
    this.onUndoPressCancel();
  },
  methods: {
    onUndoPressStart(trigger) {
      if (isMobile && trigger === 'mousedown') return;
      if (!this.canUndo) return;
      this.onUndoPressCancel();
      this.undoHoldClearTriggered = false;
      this.undoHoldTimer = window.setTimeout(() => {
        this.undoHoldClearTriggered = true;
        this.undoHoldTimer = null;
        this.$emit('clear');
      }, UNDO_HOLD_MS);
    },
    onUndoPressEnd(trigger) {
      if (isMobile && trigger === 'mouseup') return;
      if (this.undoHoldTimer) {
        clearTimeout(this.undoHoldTimer);
        this.undoHoldTimer = null;
        if (!this.undoHoldClearTriggered && this.canUndo) {
          this.$emit('undo');
        }
      }
      this.undoHoldClearTriggered = false;
    },
    onUndoPressCancel() {
      if (this.undoHoldTimer) {
        clearTimeout(this.undoHoldTimer);
        this.undoHoldTimer = null;
      }
      this.undoHoldClearTriggered = false;
    },
    isResultMatch(selection) {
      if (!this.showResultHighlights) return false;

      if (selection === 'tai') return this.resultTotal >= 11 && this.resultTotal <= 17;
      if (selection === 'xiu') return this.resultTotal >= 4 && this.resultTotal <= 10;
      if (selection === 'odd') return this.resultTotal % 2 === 1;
      if (selection === 'even') return this.resultTotal % 2 === 0;

      const [market, rawFace] = selection.split('-');
      const face = Number(rawFace);
      if (market === 'sum') return this.resultTotal === face;
      if (market === 'single') return !!this.tableResultDice && this.tableResultDice.includes(face);
      if (market === 'triple') {
        return !!this.tableResultDice && this.tableResultDice.every((die) => die === face);
      }
      return false;
    },
    playResultAnimation() {
      clearTimeout(this.resultAnimationTimer);
      this.isResultAnimating = false;
      this.$nextTick(() => {
        this.isResultAnimating = true;
        this.resultAnimationTimer = setTimeout(() => {
          this.isResultAnimating = false;
        }, 1250);
      });
    },
    onBet(selection) {
      if (!this.isBetOpen) return;
      this.$emit('bet', selection);
    },
    diceImage(face) {
      return require(`@/assets/svg/dice-items/dice-${face}.svg`);
    },
    // Game odds (the table's are Euro odds, see taiXiuGameOdds).
    oddsValue(betType, fallback) {
      const value = taiXiuGameOdds(this.table.odds && this.table.odds[betType]);
      return value === null ? fallback : value;
    },
    oddsLabel(betType, fallback) {
      return formatTaiXiuOdds(this.oddsValue(betType, fallback));
    },
    totalOdds(sum) {
      return this.oddsLabel(TaiXiuBetType.total4 + sum - 4, fallbackTotalGameOdds(sum));
    },
    selectionOdds(selection) {
      if (selection === 'tai' || selection === 'xiu') {
        return this.oddsValue(TaiXiuBetType.bigSmall, 0.97);
      }
      if (selection === 'odd' || selection === 'even') {
        return this.oddsValue(TaiXiuBetType.oddEven, 0.97);
      }

      const [market, rawFace] = selection.split('-');
      const face = Number(rawFace);
      if (market === 'sum') return this.oddsValue(TaiXiuBetType.total4 + face - 4, fallbackTotalGameOdds(face));
      if (market === 'single') {
        return this.singleFaceOdds * (this.tableResultDice || []).filter((die) => die === face).length;
      }
      if (market === 'triple') return this.oddsValue(TaiXiuBetType.triple, 120);
      return 0;
    },
    isSelectionBlocked(selection) {
      // Tài/Xỉu and Lẻ/Chẵn are exclusive: once one side is placed, the other
      // stays out for the rest of the round.
      const opposite = EXCLUSIVE_SELECTIONS[selection];
      return !!opposite && !!this.placedBets[opposite];
    },
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/mixins/_tx-result-border.scss';

$bet-zone-dim: rgba(5, 22, 32, 0.62);

.tai-xiu-board {
  position: relative;
  width: 100%;
  color: #fff;
  border-radius: 14px;
  padding: 10px;
  box-sizing: border-box;

  &:not(.fancy),
  &.fancy {
    .primary-bets > button,
    .secondary-bets button,
    .sum-grid button,
    .single-grid button {
      position: relative;
      overflow: visible;
    }

    .sum-grid button {
      min-height: 40px;
    }
  }
}

/*
 * Betting closed. One rule over the markets rather than a second, duller
 * palette per zone: open is the full colour below, closed is the same board
 * drained. The chip row, BET and the roads sit outside `.full-board-body`, so
 * they keep their own colour.
 *
 * Drained cell by cell, not on `.full-board-body`: a filter on the body is
 * painted over every cell inside it, so the result was drained with the rest
 * and could not stand out. Every cell drains -- the member's own bets too --
 * except the result, which brightens when it comes in; the bet chips stay
 * bright throughout.
 */
.tai-xiu-board.fancy.betting-closed .full-board-body {
  pointer-events: none;

  /*
   * The parity block paints its green on the wrapper, behind both halves, so a
   * drained half kept a bright wrapper behind it -- only its text dimmed, which
   * read as a recoloured label. Moved onto each half here, each drains alone.
   */
  .tx-odd-even {
    background: none;
  }

  .tx-odd-even__btn {
    background: linear-gradient(180deg, #24a35c, #157140);
  }

  .tx-info-bar {
    filter: saturate(0.25) brightness(0.5);
    transition: filter 0.3s ease;
  }

  /*
   * No outline on a drained cell. The overlay below covers the padding box, so
   * the cell's 1px border (the zone colour behind it, the divider between ODD
   * and EVEN) was left undimmed round the edge as a bright outline. The result
   * keeps its own border (`.result-matched`).
   */
  .tx-main-bet:not(.result-matched) {
    border-color: transparent;
    background-clip: padding-box;
  }

  // The divider between ODD and EVEN: its border sat over the button's own
  // gradient, which the overlay (padding box only) never dimmed, so the line
  // stayed bright. Clipped to the padding box it shows the dark board instead.
  .tx-odd-even__btn:not(.result-matched) {
    border-right-color: transparent;
    background-clip: padding-box;
  }

  /*
   * The cells dim under an overlay, not a filter: a filter on the cell would
   * dim the bet chip inside it too. Same overlay as a blocked cell (below): it
   * covers the cell's colour and label and sits under the chip
   * (bet-placed-chip.vue, z-index 2), which stays bright.
   */
  .tx-main-bet:not(.result-matched),
  .tx-odd-even__btn:not(.result-matched),
  .sum-grid button:not(.result-matched),
  :deep(.bet-triple-combo-btn:not(.bet-triple-combo-btn--result-matched)),
  :deep(.bet-dice-market__face:not(.bet-dice-market__face--result-matched)) {
    position: relative;

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      z-index: 1;
      pointer-events: none;
      background: $bet-zone-dim;
    }
  }

  /*
   * A bet's ring goes too: once betting closes only its chip marks it.
   * `!important` to meet the sum cells' own `!important` ring (`.sum-grid
   * button.selected` above); this selector is the more specific of the two.
   */
  .tx-main-bet.selected:not(.result-matched),
  .tx-odd-even__btn.selected:not(.result-matched),
  .sum-grid button.selected:not(.result-matched),
  :deep(.bet-triple-combo-btn--selected:not(.bet-triple-combo-btn--result-matched)),
  :deep(.bet-dice-market__face--selected:not(.bet-dice-market__face--result-matched)) {
    box-shadow: none !important;
  }
}

.tai-xiu-board.betting-closed:not(.fancy) {
  @mixin bet-zone-closed-dim {
    cursor: default;
    pointer-events: none;

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      z-index: 1;
      background: $bet-zone-dim;
      pointer-events: none;
    }
  }

  .tx-main-bet,
  .primary-bets button,
  .secondary-bets button,
  .sum-grid button,
  .tx-odd-even__btn {
    &:disabled {
      opacity: 1;
    }
  }

  .tx-main-bet:not(.result-matched),
  .primary-bets button:not(.result-matched),
  .secondary-bets button:not(.result-matched),
  .sum-grid button:not(.result-matched),
  .tx-odd-even__btn:not(.result-matched) {
    position: relative;
    @include bet-zone-closed-dim;
  }

  // No outline on a drained cell (see the fancy board above): the dim overlay
  // covers the padding box, so a bright 1px border was left round the edge and
  // between ODD and EVEN.
  .tx-main-bet:not(.result-matched) {
    border-color: transparent;
    background-clip: padding-box;
  }

  .tx-odd-even__btn:not(.result-matched) {
    border-right-color: transparent;
    background-clip: padding-box;
  }

  :deep(.bet-triple-combo-btn:not(.bet-triple-combo-btn--result-matched)),
  :deep(.bet-dice-market__face:not(.bet-dice-market__face--result-matched)) {
    @include bet-zone-closed-dim;
  }

  :deep(.bet-placed-chip) {
    z-index: 3;
  }
}

/*
 * The blocked half of an exclusive pair (Tài/Xỉu, Lẻ/Chẵn) is out for the rest
 * of the round once the other half is placed, so it dims like a closed zone.
 */
.tai-xiu-board {
  .tx-main-bet.blocked,
  .primary-bets button.blocked,
  .secondary-bets button.blocked,
  .tx-odd-even__btn.blocked {
    position: relative;
    cursor: default;
    pointer-events: none;

    &:disabled {
      opacity: 1;
    }

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      z-index: 1;
      background: $bet-zone-dim;
      pointer-events: none;
    }
  }
}

.board-header {
  height: 40px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  strong,
  span {
    display: block;
  }

  strong {
    color: #f3f6fa;
    font-size: 14px;

    .table-code,
    .table-id {
      display: inline;
    }
  }

  span {
    color: #7289a8;
    font-size: 13px;
  }
}

.timer {
  min-width: 38px;
  border-radius: 12px;
  padding: 4px 7px;
  color: #9ce9bb;
  background: rgba(15, 155, 82, 0.18);
  text-align: center;
  font-weight: 700;

  &.closing {
    color: #ffb5a7;
    background: rgba(214, 56, 37, 0.2);
  }
}

.mock-video {
  height: clamp(128px, 29vh, 240px);
  border-radius: 10px;
  background:
    radial-gradient(circle at 50% 42%, rgba(215, 154, 60, 0.22), transparent 26%),
    linear-gradient(135deg, #0b213b, #160f21);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  margin-bottom: 8px;

  &::before {
    content: '';
    position: absolute;
    inset: 12px;
    border: 1px solid rgba(252, 199, 81, 0.13);
    border-radius: 50%;
  }

  .video-label {
    position: absolute;
    top: 9px;
    left: 10px;
    color: #8497b1;
    font-size: 10px;
    text-transform: uppercase;
  }

  small {
    color: #6d8099;
    margin-top: 9px;
  }
}

.dice-result {
  display: flex;
  gap: 9px;
  z-index: 1;

  img {
    width: 42px;
    height: 42px;
    display: block;
    box-shadow: 0 6px 13px rgba(0, 0, 0, 0.4);
  }

  &.rolling img {
    animation: dice-roll 3s ease-in-out both;

    &:nth-child(2) {
      animation-delay: 0.14s;
    }

    &:nth-child(3) {
      animation-delay: 0.28s;
    }
  }

  &.continuous img {
    animation-iteration-count: infinite;
  }
}

.primary-bets,
.secondary-bets,
.sum-grid,
.chips,
.board-actions,
.recent-results {
  display: flex;
  gap: 6px;
}

.primary-bets button,
.secondary-bets button,
.sum-grid button {
  border: 1px solid #35465d;
  color: #A5BAFF;
  background: #13243a;
  cursor: pointer;

  &.selected {
    border-color: #f7bd57;
    box-shadow: inset 0 0 0 1px rgba(247, 189, 87, 0.4);
  }

  em {
    display: block;
    color: #ffd27d;
    font-size: 9px;
    font-style: normal;
  }
}

.primary-bets {
  button {
    flex: 1;
    min-height: 65px;
    border-radius: 10px;
    background: linear-gradient(145deg, #742c23, #351c29);

    &:last-child {
      background: linear-gradient(145deg, #174c76, #162b4c);
    }

    span,
    strong,
    small {
      display: block;
    }

    span {
      font-size: 18px;
      font-weight: 600;
    }

    strong {
      color: #B2DBFE;
      font-size: 14px;
      margin-top: 2px;
    }

    small {
      color: #aebcd0;
      margin-top: 2px;
    }
  }
}

.sum-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  margin-top: 6px;

  button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    text-align: center;
    min-height: 40px;
    height: 40px;
    padding: 5px 1px 4px;
    border: 0 !important;
    border-radius: 6px;
    color: #a5baff;
    background: url('~@/assets/images/sum-bet-btn.svg') center/100% 100% no-repeat;
    box-sizing: border-box;
    font-weight: 700;
    cursor: pointer;

    strong,
    small {
      display: block;
    }

    strong {
      font-size: 18px;
      font-weight: 700;
      line-height: 22px;
      color: #a5baff;
    }

    small {
      margin-top: 2px;
      color: #758ac9;
      font-size: 10px;
      font-weight: 700;
      line-height: 12px;
      white-space: nowrap;
    }

    // Placed: the zone keeps its colour and takes the gold ring and the lift.
    &.selected {
      border: 0 !important;
      box-shadow: inset 0 0 0 2px #e6cf87, inset 0 0 0 999px rgba(255, 255, 255, 0.08) !important;
      outline: none;

      strong {
        color: #fff;
      }

      small {
        color: #a5baff;
      }
    }
  }
}

.secondary-bets {
  margin-top: 6px;

  button {
    flex: 1;
    min-height: 32px;
    border-radius: 7px;
  }
}

.single-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 6px;
  margin-top: 6px;

  button {
    min-height: 43px;
    padding: 2px;
    border: 1px solid #35465d;
    border-radius: 6px;
    background: linear-gradient(180deg, #504564, #3b3958);
    cursor: pointer;

    img {
      width: 20px;
      height: 20px;
      display: block;
      margin: 0 auto;
    }

    em {
      color: #ffd27d;
      font-size: 8px;
      font-style: normal;
    }

    &.selected {
      border-color: transparent !important;
      box-shadow: none !important;
      background: url('~@/assets/images/single-bet-btn-active.svg') center/100% 100% no-repeat !important;
    }
  }
}

.single-odds {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;

  span {
    height: 20px;
    min-height: 20px;
    padding: 0 4px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ad94ad;
    background: rgba(157, 110, 124, 0.3);
    border-radius: 0;
    font-size: 10px;
    font-weight: 800;
    line-height: 1;
    text-align: center;
    white-space: nowrap;

    &:first-child {
      border-bottom-left-radius: 6px;
    }

    &:last-child {
      border-bottom-right-radius: 6px;
    }
  }
}

.chips {
  justify-content: center;
  overflow-x: auto;
  padding: 9px 1px;

  .chip-option {
    flex: 0 0 44px;
    width: 44px;
    height: 44px;
    min-height: 44px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: transparent;
    cursor: pointer;

    &.active {
      transform: translateY(-2px);

      .tai-xiu-chip {
        border-color: rgba(255, 255, 255, 0.8);
        box-shadow: 0 0 6px #fff;
      }
    }
  }

  .tai-xiu-chip {
    width: 44px;
    height: 44px;
    min-width: 44px;
    min-height: 44px;
    max-width: 44px;
    padding: 0;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.board-actions {
  align-items: center;

  button {
    min-height: 34px;
    border-radius: 8px;
    cursor: pointer;

    &:disabled {
      opacity: 0.4;
      cursor: default;
    }
  }

  .text-action {
    border: 1px solid #35465d;
    color: #a9b6c9;
    background: #101f33;
    padding: 0 10px;
  }

  .bet-action {
    flex: 1;
    border: 1px solid #d68c31;
    color: #fff;
    background: linear-gradient(180deg, #9d5b20, #613514);
    font-weight: 800;

    small {
      display: block;
      color: #ffe7ba;
    }
  }
}

.feedback {
  min-height: 14px;
  margin: 7px 0 0;
  color: #fcc751;
  font-size: 11px;
  text-align: center;
}

.recent-results {
  align-items: center;
  overflow-x: auto;
  margin-top: 7px;

  span {
    color: #7185a0;
    font-size: 10px;
    white-space: nowrap;
  }

  i {
    flex: 0 0 24px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: grid;
    place-items: center;
    font-size: 9px;
    font-style: normal;
    font-weight: 800;
    background: #1f5b84;

    &.tai {
      background: #8e372c;
    }
  }
}

.fancy {
  width: 100%;
  max-width: none;
  min-height: 410px;
  overflow-x: hidden;
  overflow-y: visible;
  border-radius: 16px;
  padding: 8px;
  background: #051620;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  &.compact {
    min-height: 0;
  }

  .board-header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    margin-bottom: 4px;
    flex: 0 0 40px;

    .table-identity {
      position: relative;
      z-index: 1;
      min-width: 0;
      flex: 0 1 auto;

      strong {
        display: flex;
        gap: 4px;
        font-size: 13px;
        font-weight: 700;
        white-space: nowrap;
      }

      .table-code {
        color: #fff;
      }

      .table-id {
        color: #efc87f;
      }
    }

    // The same pill and dice as the table bar (tai-xiu-board-header.vue).
    .header-dice {
      position: absolute;
      left: 50%;
      top: 50%;
      z-index: 0;
      width: auto;
      min-width: 80px;
      height: 40px;
      padding: 4px 12px;
      border-radius: 20px;
      border: solid 1px rgba(49, 61, 101, 0.8);
      background-color: rgba(21, 30, 55, 0.8);
      box-sizing: border-box;
      white-space: nowrap;
      transform: translate(-50%, -50%);
      pointer-events: none;

      :deep(.tx-die) {
        width: 30px;
        height: 30px;
      }
    }

    .time {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      gap: 11px;
      flex: 0 0 auto;
      margin-left: auto;
    }

    .timer {
      min-width: 0;
      padding: 0;
      border-radius: 0;
      color: #efc87f;
      background: transparent;
      font-size: 18px;
      font-weight: 700;
      white-space: nowrap;

      &.closing {
        color: #fa6f6f;
        background: transparent;
      }
    }

    .sheet-close {
      width: 22px;
      height: 22px;
      padding: 0;
      border: 0;
      background: transparent;
      display: block;
      flex: 0 0 22px;
      cursor: pointer;

      img {
        width: 22px;
        height: 22px;
        display: block;
      }
    }
  }

  .feedback {
    display: none;
  }

  .primary-bets,
  .secondary-bets,
  .sum-grid,
  .single-grid,
  .single-odds,
  .board-actions {
    flex: 0 0 auto;
  }

  .primary-bets {
    display: grid;
    grid-template-columns: minmax(0, 130fr) minmax(0, 106fr) minmax(0, 130fr);
    gap: 4px;
    margin-top: 4px;

    .primary-bet-tai {
      color: #ff9d9d;

      &.selected {
        border-color: #d93939 !important;
        background: linear-gradient(to bottom, #c11919, rgba(177, 31, 31, 0.6)) !important;
      }

      &.sub {
        color: #ff9c9d;
      }

      .odds {
        color: #ac8484;
        font-weight: 600;
      }
    }

    .primary-bet-xiu {
      color: #b1dbff;

      &.sub {
        color: #b2dbfe;
      }

      .odds {
        color: #94a4d6;
        font-weight: 700;
      }
    }

    > button {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      height: 96px;
      min-height: 96px;
      padding: 8px 4px;
      box-sizing: border-box;
      border: 1px solid #d93939;
      border-radius: 12px;
      background: linear-gradient(to bottom, #c11919, rgba(177, 31, 31, 0.6)) !important;

      &.selected {
        border-color: #fff !important;
        box-shadow: none;

        > span,
        > .sub,
        > small,
        > .odds {
          color: #fff;
        }
      }

      &:last-child {
        border-color: #539afa;
        background: linear-gradient(to bottom, #3c7de5, rgba(30, 90, 203, 0.6)) !important;

        &.selected {
          border-color: #fff !important;
          background: linear-gradient(to bottom, #3c7de5, rgba(30, 90, 203, 0.6)) !important;
        }
      }

      span,
      small,
      em {
        display: block;
      }

      span {
        font-size: 28px;
        font-weight: 700;
        line-height: 1.05;
        text-transform: uppercase;
      }

      .sub {
        margin-top: 1px;
        font-size: 14px;
        font-weight: 700;
        line-height: 1.1;
      }

      small {
        margin-top: 1px;
        font-size: 12px;
        line-height: 1.1;
      }

      em {
        margin-top: 2px;
        color: #ffd27d;
        font-size: 9px;
        font-style: normal;
      }
    }
  }

  .secondary-bets {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin: 0;

    button {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      flex: 1;
      height: 46px;
      min-height: 0;
      padding: 4px 2px;
      box-sizing: border-box;
      border: 1px solid #0c836c;
      border-radius: 8px 8px 0 0;
      color: #75c9a5;
      background: linear-gradient(to bottom, #166a5a, rgba(22, 106, 90, 0.3)) !important;
      font-weight: 700;

      &.selected {
        border-color: #17d3af;
        box-shadow: none;
        color: #fff;
        background: linear-gradient(to bottom, #178671, rgba(31, 147, 125, 0.4)) !important;

        > span,
        > small {
          color: #fff;
        }
      }

      &:last-child {
        border-radius: 0 0 8px 8px;
      }

      span,
      small,
      em {
        display: block;
      }

      span {
        font-size: 13px;
        line-height: 1.1;
      }

      small {
        margin-top: 1px;
        color: #7ca392;
        font-size: 12px;
        font-weight: 700;
        line-height: 1.1;
      }

      em {
        margin-top: 1px;
        color: #ffd27d;
        font-size: 8px;
        font-style: normal;
      }
    }
  }

  &.full {
    min-height: auto;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  :deep(.bet-dice-market) {
    margin-bottom: 5px;
  }

  .sum-grid {
    display: grid;
    grid-template-columns: repeat(7, minmax(0, 1fr));
    gap: 0;
    margin-top: 0;

    button {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      height: 42px;
      min-height: 42px;
      margin: 0;
      padding: 4px 1px;
      border: none !important;
      border-radius: 0;
      border-right: 1px solid #1e2e4e !important;
      border-bottom: 1px solid #1e2e4e !important;
      color: #fff;
      background: linear-gradient(180deg, #22416f, #18325a);
      box-sizing: border-box;
      cursor: pointer;

      &:nth-child(7n) {
        border-right: none !important;
      }

      &.selected {
        border-right: 1px solid #1e2e4e !important;
        border-bottom: 1px solid #1e2e4e !important;
        box-shadow: inset 0 0 0 2px #e6cf87, inset 0 0 0 999px rgba(255, 255, 255, 0.08);
        outline: none;

        &:nth-child(7n) {
          border-right: none !important;
        }

        strong,
        small {
          color: white;
        }
      }

      &.result-matched {
        @include tx-result-matched-border;
        border: none !important;
        border-right: none !important;
        border-bottom: none !important;
      }

      strong,
      small,
      em {
        display: block;
      }

      strong {
        font-size: 16px;
        font-weight: 700;
        color: #fff;
      }

      small {
        margin-top: 2px;
        color: #c9d7ee;
        font-size: 10px;
        font-weight: 700;
        line-height: 12px;
        white-space: nowrap;
      }

      em {
        margin-top: 1px;
        color: #fff;
        font-size: 8px;
        font-style: normal;
        line-height: 1;
      }
    }

    &:last-child button {
      border-bottom: none !important;

      &.selected,
      &.result-matched {
        border-bottom: none !important;
      }
    }
  }

  .single-odds {
    gap: 4px;

    span {
      font-weight: 700;
      border-radius: 0;

      &:first-child {
        border-bottom-left-radius: 6px;
      }

      &:last-child {
        border-bottom-right-radius: 6px;
      }
    }
  }

  .single-grid {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 3px;
    margin: 10px 0 5px;

    button {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 42px;
      min-height: 42px;
      padding: 2px;
      border: 1px solid #4d5077 !important;
      border-radius: 0;
      background: linear-gradient(180deg, #504564, #3b3958) !important;
      cursor: pointer;

      &:nth-child(1),
      &:nth-child(4) {
        border-top-left-radius: 5px;
      }

      &:nth-child(3),
      &:nth-child(6) {
        border-top-right-radius: 5px;
      }

      img {
        width: 20px;
        height: 20px;
        display: block;
      }

      &.selected {
        border-color: transparent !important;
        box-shadow: none !important;
        background: url('~@/assets/images/single-bet-btn-active.svg') center/100% 100% no-repeat !important;
      }

      em {
        margin-top: 1px;
        color: #ffd27d;
        font-size: 8px;
        font-style: normal;
        line-height: 1;
      }
    }
  }

  .board-actions {
    display: grid;
    grid-template-columns: 40px 180px 48px 80px;
    gap: 4px;
    margin-top: auto;
    padding-top: 16px;
    align-items: center;
    overflow: visible;
    justify-content: space-between;

    .undo-action {
      width: 40px;
      height: 40px;
      padding: 0;
      border: 0;
      border-radius: 0;
      color: #acbff2;
      background: transparent;
      display: flex;
      flex-direction: column;
      align-items: center;

      img,
      small {
        display: block;
      }

      img {
        width: 36px;
        height: 36px;
      }

      small {
        width: 40px;
        height: 13px;
        margin-top: -9px;
        border-radius: 4px;
        background: #324a8d;
        font-size: 10px;
        font-weight: 700;
        line-height: 13px;
        text-transform: uppercase;
        position: relative;
      }
    }

    .chips {
      width: 180px;
      max-width: 180px;
      min-width: 0;
      min-height: 52px;
      padding: 8px 6px;
      gap: 2px;
      display: flex;
      flex-wrap: nowrap;
      justify-content: flex-start;
      align-items: center;
      box-sizing: border-box;
      overflow-x: auto;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }

      .chip-option {
        flex: 0 0 36px;
        width: 36px;
        height: 36px;
        min-height: 36px;
        padding: 0;
        border: 0;
        border-radius: 50%;
        background: transparent;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        &.active .quick-chip {
          border-color: rgba(255, 255, 255, 0.8);
          box-shadow: 0 0 6px #fff;
        }
      }

      .quick-chip {
        position: relative;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        border: 1px solid transparent;
        box-sizing: border-box;
        flex: 0 0 36px;
        pointer-events: none;

        img {
          width: 100%;
          height: 100%;
          display: block;
        }

        .quick-chip-value {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-weight: 600;
          color: #fff;
          text-shadow: 0 0 5px rgba(88, 88, 88, 0.9);
          line-height: 1;
          white-space: nowrap;
        }
      }
    }

    .stake-total {
      min-width: 48px;
      color: #d5def0;

      span,
      strong {
        display: block;
      }

      span {
        font-size: 9px;
        font-weight: 700;
      }

      strong {
        margin-top: 3px;
        font-size: 11px;
        white-space: nowrap;
      }
    }

    .bet-action {
      flex: none;
      width: 80px;
      min-width: 80px;
      height: 36px;
      min-height: 36px;
      padding: 0;
      border: 0;
      border-radius: 0;
      color: #59401a;
      background: url('~@/assets/images/bet-btn-tx.webp') center/100% 100% no-repeat;
      box-shadow: none;
      font-size: 18px;
      font-weight: 700;
      text-transform: uppercase;
    }
  }
}

.full-board-body {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  min-height: 0;
}

/*
 * Mockup 1b (approved): the chip row and BET stay pinned to the bottom of the
 * scrolling board, so they are reachable from the moment the board loads --
 * before, the Single/Double row and the roads pushed them under the phone's
 * toolbars with no way to scroll to them.
 */
::v-deep .bet-board-actions--fancy {
  position: sticky;
  bottom: 0;
  z-index: 2;
  background: #061820;
  box-shadow: 0 -10px 18px rgba(0, 0, 0, 0.6);
}

.full {
  width: 100%;
  max-width: none;

  &:not(.fancy) {
    flex-shrink: 0;
  }
}

// v1.1 header bars: "ALL PAY", "TRIPLE" and the "SINGLE / DOUBLE / TRIPLE" divider
// above the dice-market row. Shared visual language across the full-game and
// quickplay boards so both can be built from the same markup.
.tx-info-bar {
  height: 18px;
  min-height: 18px;
  margin-top: 2px;
  padding: 0 8px;
  border-radius: 8px 8px 0 0;
  background: #1d292a;
  color: #e6cf87;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  white-space: nowrap;

  &--triple,
  &--single {
    justify-content: space-between;
    padding: 0 12px;
    border-radius: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      flex: 1;
      text-align: center;
    }
  }
}

.tx-main-row {
  display: flex;
  align-items: stretch;
  min-width: 0;
  height: 73px;
  min-height: 73px;

  > .tx-main-bet,
  > .tx-odd-even {
    flex: 1 1 0;
    min-width: 0;
    min-height: 0;
    height: auto;
    align-self: stretch;
  }
}

.tx-main-bet {
  position: relative;
  overflow: visible;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0;
  padding: 8px 4px;
  box-sizing: border-box;
  border: 1px solid transparent;
  cursor: pointer;

  span,
  small {
    display: block;
  }

  span {
    font-size: 28px;
    font-weight: 700;
    line-height: 1.05;
    text-transform: uppercase;
  }

  .sub {
    margin-top: 1px;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.1;
    white-space: nowrap;

    @media screen and (max-width: 400px) {
      font-size: 10px;
    }
  }

  &--tai {
    border-color: transparent;
    background: linear-gradient(160deg, #c33a2f, #a01f1f 55%, #6b1414);

    > span:not(.sub) {
      color: #fff;
    }

    .sub {
      color: rgba(255, 255, 255, 0.82);
    }
  }

  &--xiu {
    border-color: transparent;
    background: linear-gradient(200deg, #3a86dc, #1f62b8 50%, #0d3f7a);

    > span:not(.sub) {
      color: #fff;
    }

    .sub {
      color: rgba(255, 255, 255, 0.82);
    }
  }

  /*
   * A placed bet keeps the zone's own colour and gains a gold ring and a slight
   * lift -- the second inset shadow is the 8% white wash. Swapping the colour
   * made an open board look like only one zone was live.
   */
  &.selected {
    border-color: transparent;
    box-shadow: inset 0 0 0 2px #e6cf87, inset 0 0 0 999px rgba(255, 255, 255, 0.08);

    > span,
    > .sub,
    > small {
      color: #fff;
    }
  }
}

.tx-odd-even {
  display: flex;
  align-items: stretch;
  box-sizing: border-box;
  border: 1px solid transparent;
  background: linear-gradient(180deg, #24a35c, #157140);
  overflow: hidden;
}

.tx-odd-even__btn {
  position: relative;
  overflow: visible;
  flex: 1 1 0;
  min-width: 0;
  min-height: 0;
  height: auto;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0;
  padding: 0 2px;
  box-sizing: border-box;
  border: 0;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  color: #fff;
  background: transparent;
  cursor: pointer;

  &:last-child {
    border-right: 0;
  }

  span,
  small {
    display: block;
  }

  span {
    font-size: 16px;
    font-weight: 700;
    text-transform: uppercase;

    @media screen and (max-width: 400px) {
      font-size: 16px;
    }
  }

  small {
    margin-top: 2px;
    color: rgba(255, 255, 255, 0.82);
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;

    @media screen and (max-width: 400px) {
      font-size: 10px;
    }
  }

  &.selected {
    box-shadow: inset 0 0 0 2px #e6cf87, inset 0 0 0 999px rgba(255, 255, 255, 0.08);

    small {
      color: #fff;
    }
  }
}

.tx-triple-section {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 100%;
  min-width: 0;
}

.tx-triple-row {
  display: flex;
  flex-shrink: 0;
  height: 40px;
  min-height: 40px;
  box-sizing: border-box;
  border: 1px solid #1e2e4e;
  overflow: hidden;

  :deep(.bet-triple-combo-btn) {
    flex: 1;
    min-width: 0;
    justify-content: center;
    border: none;
    border-radius: 0;
    border-right: 1px solid #1e2e4e;
    background: linear-gradient(180deg, #22416f, #18325a);

    &:last-child {
      border-right: none;
    }

    &.bet-triple-combo-btn--selected {
      background: linear-gradient(180deg, #22416f, #18325a);
      box-shadow: inset 0 0 0 2px #e6cf87, inset 0 0 0 999px rgba(255, 255, 255, 0.08);
    }

    &.bet-triple-combo-btn--result-matched {
      @include tx-result-matched-border;
      border: none !important;
      border-right: none !important;
    }
  }

  :deep(.bet-triple-combo-btn__odds) {
    display: none;
  }
}

.full-sum-rows {
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 0;
  min-height: 0;
  box-sizing: border-box;
  border: 1px solid #1e2e4e;
  overflow: hidden;

  .sum-grid {
    margin-top: 0;
  }
}

.tx-dice-market {
  :deep(.bet-dice-market__labels) {
    display: none;
  }

  // Same cell as the 4-17 grid, so the single/double/triple row reads as part
  // of the same open board.
  :deep(.bet-dice-market__face) {
    background: linear-gradient(180deg, #22416f, #18325a);

    &.bet-dice-market__face--selected {
      background: linear-gradient(180deg, #22416f, #18325a);
      box-shadow: inset 0 0 0 2px #e6cf87, inset 0 0 0 999px rgba(255, 255, 255, 0.08);
    }
  }
}

.tai-xiu-board {
  :deep(.bet-triple-combo-btn--result-matched),
  :deep(.bet-dice-market__face--result-matched) {
    @include tx-result-matched-border;
    color: #fff !important;
  }
}

.tai-xiu-board button.result-matched,
.tai-xiu-board.fancy button.result-matched,
.tai-xiu-board button.result-matched.selected,
.tai-xiu-board.fancy button.result-matched.selected {
  @include tx-result-matched-border;
  color: #fff !important;

  > strong,
  > span,
  > small,
  > em {
    color: #fff !important;
  }
}

@keyframes dice-roll {
  0% {
    transform: rotate(0deg) scale(1);
  }
  11% {
    transform: rotate(180deg) scale(0.86);
  }
  22%,
  100% {
    transform: rotate(360deg) scale(1);
  }
}

@media (prefers-reduced-motion: reduce) {
  .dice-result.rolling img {
    animation: none;
  }

  .tai-xiu-board button.result-matched,
  .tai-xiu-board :deep(.bet-triple-combo-btn--result-matched),
  .tai-xiu-board :deep(.bet-dice-market__face--result-matched) {
    animation: none;
    box-shadow: 0 0 8px rgba(255, 229, 159, 0.65);
  }
}

@media screen and (max-width: 360px) {
  .fancy {
    padding-right: 7px;
    padding-left: 7px;

    .primary-bets > button {
      min-height: 82px;
    }

    .board-header {
      .table-identity {
        min-width: 0;

        strong {
          font-size: 12px;
        }
      }
    }

    .header-dice {
      width: auto;
      min-width: 108px;
      gap: 4px;
      padding-right: 8px;
      padding-left: 8px;

      :deep(.tx-die) {
        width: 26px;
        height: 26px;
      }
    }
  }
}
</style>
